<script lang="ts">
  import { Col, Container, Form, Input, Row, InputGroup, InputGroupText, FormGroup } from "sveltestrap";
  import BookmarkSearchResult from "./BookmarkSearchResult.svelte";
  import Card from "../../Core/Card.svelte";
  import SerachNav from "./SerachNav.svelte";
  import AllData from "./AllData.svelte";
  import ImageData from "./ImageData.svelte";
  import VideosData from "./VideosData.svelte";
</script>
<BookmarkSearchResult />
<Container fluid class="search-page">
    <Row>
      <Col sm="12"> 
        <Card cardHeaderprops="pb-0">
          <div slot="customheader">
            <Form class="search-form">
              <FormGroup class="m-0">
                <InputGroup>
                    <InputGroupText><i class="icon-search"></i></InputGroupText>
                    <Input class="form-control-plaintext" type="search" placeholder="Search .." />
                </InputGroup>
              </FormGroup>
            </Form>
          </div>
          <div slot="contentbody">
            <SerachNav />
            <div class="tab-content" id="tabContent">
               <AllData />
               <ImageData />
               <VideosData />
            </div>
          </div>
        </Card>
      </Col>
    </Row>
</Container>